module.exports = __webpack_public_path__ + "static/media/Jolyne BG.d5386231.png";